import { BaseDto } from '../base.dto';
import { IsBoolean, IsDefined, IsInt, IsISO8601, IsOptional, Matches, Max, Min } from 'class-validator';

export class StockLevelCreateDto extends BaseDto {
  @IsDefined()
  @IsInt()
  stockCategoryId: number;

  @IsDefined()
  @IsInt()
  merchantId: number;

  @IsDefined()
  @IsInt()
  costCentreId: number;

  @IsDefined()
  @IsBoolean()
  closed: boolean;

  @IsDefined()
  @IsBoolean()
  finalized: boolean;

  @IsDefined()
  @IsInt()
  @Min(1970)
  @Max(2100)
  year: number;

  @IsOptional()
  @IsInt()
  @Min(1)
  @Max(12)
  monthNo?: number;

  @IsOptional()
  @IsInt()
  @Min(1)
  @Max(53)
  weekNo?: number;

  @IsOptional()
  @IsISO8601()
  @Matches(/^\d{4}-\d{2}-\d{2}$/)
  countedDate?: string;

  @IsOptional()
  @IsBoolean()
  beforeTrading?: boolean;

  @IsOptional()
  @IsISO8601()
  countedDateTime?: Date;
}